(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ProfileNotificationDeleteController', ProfileNotificationDeleteController);

    ProfileNotificationDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomerNotification'];

    function ProfileNotificationDeleteController($uibModalInstance, entity, CustomerNotification) {
        var vm = this;

        vm.notification = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomerNotification.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
